import { render, staticRenderFns } from "./default.vue?vue&type=template&id=520d59f9"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuLanguage: require('/builds/constructiva/laravel_lpmanager/frontend/components/menu/Language.vue').default,MenuTenant: require('/builds/constructiva/laravel_lpmanager/frontend/components/menu/Tenant.vue').default,MenuAdmin: require('/builds/constructiva/laravel_lpmanager/frontend/components/menu/Admin.vue').default,MenuUser: require('/builds/constructiva/laravel_lpmanager/frontend/components/menu/User.vue').default})
